export default __webpack_public_path__ + "static/media/2_0084.b355fcd6.webp";